let cardsCount;

if (window.innerWidth < 720) {
    cardsCount = 6;
};
if (window.innerWidth > 720 && window.innerWidth < 960) {
    cardsCount = 6;
};
if (window.innerWidth > 960) {
    cardsCount = 15;
};

$('[data-toggle="cards-list"]').click(function () {
    const classes = {
        default: {
            active: 'btn btn-sm btn-gray btn-chip toggle-on',
            default: 'btn btn-sm btn-gray btn-chip'
        },
        bw: {
            active: 'bw btn btn-md btn-dark btn-md-sm',
            default: 'bw btn btn-md btn-outlined btn-grey btn-md-sm'
        }
    };
    const mode = $(this).attr('data-mode') || 'default';
    const group = $(this).attr('data-toggle-group');
    const targetContainer = $(this).attr('data-target-container');
    const showMore = $(`[data-showmore="toggler"][data-target="${targetContainer}"]`);
    const cards = $(`${targetContainer} > *`);
    const filter = $(this).text();
    const cardsCountCustom = $(targetContainer).attr('data-counts').split(',');

    if (window.innerWidth < 720) {
        var cardsCount = cardsCountCustom ? cardsCountCustom[0] : 3;
    };
    if (window.innerWidth > 720 && window.innerWidth < 960) {
        var cardsCount = cardsCountCustom ? cardsCountCustom[1] : 6;
    };
    if (window.innerWidth > 960) {
        var cardsCount = cardsCountCustom ? cardsCountCustom[2] : 9;
    };

    cards.each(function (index) {
        $(this).toggleClass('d-none', index >= cardsCount)
    })

    showMore.removeClass('d-none');

    if ($(this).hasClass(classes[mode].active)) {
        $(this).attr('class', classes[mode].default);
        cards.each(function (index) {
            $(this).toggleClass('d-none', index >= cardsCount)
        })
        showMore.attr('data-tag', 'all');
        return;
    }

    showMore.attr('data-tag', filter);

    $(`[data-toggle-group="${group}"]`).each(function () { $(this).attr('class', classes[mode].default) });
    $(this).attr('class', classes[mode].active);

    cards.addClass('d-none');

    var cardsFilter = [];

    cards.each(function () {
        let tags = $(this).attr('data-tags');

        if (tags.search(filter) != -1) {
            cardsFilter.push($(this));
        }
    })

    $(cardsFilter).each(function (index) {
        $(this).toggleClass('d-none', index >= cardsCount)
    })

    showMore.toggleClass('d-none', $(cardsFilter).length <= cardsCount);
});

if ($('[data-showmore]')) {

    $('[data-showmore="container"]').each(function () {
        const parent = $(this).attr("id");
        const toggler = $(`[data-showmore="toggler"][data-target="#${parent}"]`);
        const cards = $(`#${parent} [data-showmore="item"]`);
        var cardsCount, cardsCountCustom;

        let settings = {
            'counts': $(this).attr("data-counts").split(','),
            'countsCustom': $(this).attr("data-opens-custom")
        }

        function recalcCounts(settings) {
            if (window.innerWidth < 720) cardsCount = settings.counts[0];
            if (window.innerWidth > 720 && innerWidth < 960) settings.cardsCount = settings.counts[1];
            if (window.innerWidth > 960) cardsCount = settings.counts[2];

            if (settings.countsCustom) {
                const countsCustom = settings.countsCustom.split(',');

                if (window.innerWidth < 720) cardsCountCustom = countsCustom[0] === 'all' ? cards.length : countsCustom[0];
                if (window.innerWidth > 720 && window.innerWidth < 960) cardsCountCustom = countsCustom[1] === 'all' ? cards.length : countsCustom[1];
                if (window.innerWidth > 960) cardsCountCustom = countsCustom[2] === 'all' ? cards.length : countsCustom[2];
            }
        }

        recalcCounts(settings);

        $(window).resize(function () {
            recalcCounts(settings);
        })

        toggler.attr('data-tag', 'all');

        function defaultState() {
            cards.each(function (index) {
                $(this).toggleClass('d-none', index >= cardsCount)
            });
            $(toggler).html($(toggler).attr('data-showmore-text'));
        }

        defaultState();

        function returnState() {
            console.log(toggler);
            $(toggler).html($(toggler).attr('data-return-text'));
        }

        toggler.toggleClass('d-none', cards.length < cardsCount);

        toggler.click(function () {
            const openCaseCount = () => {
                if (cardsCountCustom) {
                    return cardsCountCustom > 0 ? cardsCountCustom : cardsCount;
                } else {
                    return cardsCount;
                }
            }

            const group = $(this).attr('data-tag');

            let cardsHidden = $(`#${parent}>.d-none`);

            if (group == 'all') {
                $(cardsHidden).each(function (index) {
                    $(this).toggleClass('d-none', index >= openCaseCount())
                });

                if (cardsHidden.length <= openCaseCount()) returnState();
            } else {
                var cardsFilter = [];

                cardsHidden.each(function () {
                    let tags = $(this).attr('data-tags').split(',');

                    if ($.inArray(group, tags) >= 0) {
                        cardsFilter.push($(this));
                    }
                });

                $(cardsFilter).each(function (index) {
                    $(this).toggleClass('d-none', index >= openCaseCount())
                });

                if (cardsFilter.length <= openCaseCount()) returnState();
            }

            if (!cardsHidden.length) defaultState();
        })
    })
}